import { SettingsLayout, type SettingsNavSection } from '@/components/settings/SettingsLayout.tsx';

/**
 * Account settings — the personal counterpart to `/admin`.
 *
 * Nothing here is gated — every section is about the signed-in user.
 *
 * Notifications used to be the second group here and now live at `/notifications`:
 * the inbox is a daily read rather than a preference, and pairing it with the rules
 * and the delivery log put "what reached me" next to "why". Account settings is what
 * is left: who you are, and how you get in.
 */
const AccountLayout = () => {
  const sections: SettingsNavSection[] = [
    {
      label: 'Account',
      visible: true,
      items: [
        { to: '/account/profile', label: 'Profile' },
        { to: '/account/emails', label: 'Email addresses' },
        { to: '/account/security', label: 'Security' },
        { to: '/account/assistants', label: 'AI assistants' },
        { to: '/account/vpn', label: 'VPN devices' },
      ],
    },
  ];

  return <SettingsLayout sections={sections} ariaLabel="Account sections" />;
};

export default AccountLayout;
